<template>
  <div>
    <div class="imap pc" v-if="isDesktop">
      <div class="icontact">
        <div class="w">
          <div class="headx">
            <h2>
              <em>
                <b>联系</b>我们
              </em>
              <span></span>
            </h2>
            <a href="/contact" class="mo">MORE+</a>
          </div>
          <div class="wd">
            <span>
              请填写完整以下信息，或者直接联系我们，
              <br />我们将会给您尽快的回复！
            </span>
            <div class="tel3 s">
              <span class="fs14">电话：</span>
              <span ig-phone>{{ nowData.company_mobile }}</span>
            </div>
            <!-- <div class="iemail s"></div> -->
            <div class="iadd s">{{ nowData.address }}</div>
          </div>
          <div class="imessage">
            <p>在线报名</p>
            <div class="comt">
              <form action="/?message/" method="post" @submit.prevent="submitForm">
                <ul>
                  <li>
                    <label for></label>
                    <input
                      type="text"
                      class="name txt"
                      v-model="contacts"
                      placeholder="请输入您的姓名"
                      maxlength="46"
                      id="name"
                    />
                  </li>
                  <li>
                    <label for></label>
                    <input
                      type="text"
                      class="name txt"
                      v-model="mobile"
                      placeholder="请输入您的电话"
                      maxlength="40"
                      id="tel"
                    />
                  </li>
                  <li style="float:none;width:637px;">
                    <label for></label>
                    <textarea
                      type="text"
                      v-model="content"
                      name="content"
                      id="content"
                      placeholder="请输入您的问题"
                    ></textarea>
                  </li>
                  <!-- <input type="submit" class="button1" value="提  交" id="submit" /> -->
                  <button type="submit" class="button1">提交</button>
                </ul>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="move" v-else>
      <section class="icontact">
        <div class="ihead">
          <h2 class="tit">
            <div class="itit">
              <span>
                <i>联系</i>我们
              </span>
              <em>CONTACT</em>
            </div>
          </h2>
        </div>
        <ul class="tod">
          <li class="ico1">
            <span>公司名称：</span>{{ nowData.company_name }}
          </li>
          <li class="ico2">
            <span>联系ＱＱ：</span>
            <a href="http://wpa.qq.com/msgrd?v=3&amp;uin=&amp;site=qq&amp;menu=yes">点击交谈</a>
          </li>
          <li class="ico3">
            <span>联系邮箱：</span>{{ nowData.company_tel }}
          </li>
          <li class="ico4">
            <span>联系电话：</span>
            <a href="tel:18660779222" class="format428">{{ nowData.company_mobile }}</a>
          </li>
        </ul>
      </section>
      <footer class="footer">版权所有：{{ nowData.copyright }}</footer>
    </div>
  </div>
</template>

<script>
import method from "@/utils/Untitl.js";
export default {
  data() {
    return {
      contacts: "",
      mobile: "",
      content: "",
      isDesktop: window.innerWidth > 428,
      http: process.env.VUE_APP_BASE_API,
      nowData:[],
    };
  },
  mounted() {
    // 监听窗口大小变化
    window.addEventListener("resize", this.handleResize);
    this.getContact();
  },
  beforeDestroy() {
    // 移除事件监听器
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    handleResize() {
      // 根据窗口宽度更新 isDesktop 状态
    },
    async getContact() {
       const res = await method.base_info();
       if (res.code == 1) {
        this.nowData = res.data;
       }
      // // console.log(this.nowData);
    },
    submitForm() {
      if (this.contacts === "") {
        this.$message.error('请输入您的姓名！');

        return;
      }
      if (this.mobile === "") {
        this.$message.error('请输入你的手机！');

        return;
      }
      const phoneRegex =
        /^(((13[0-9]{1})|(14[0-9]{1})|(15[0-9]{1})|(16[0-9]{1})|(17[0-9]{1})|(18[0-9]{1})|(19[0-9]{1}))+\d{8})$/;
      if (!phoneRegex.test(this.mobile)) {
        this.$message.error('手机号码格式不正确！');

        return;
      }
      // 若验证通过，可在此提交表单
      this.message();
    },
    async message() {
      const res = await method.message(this.contacts, this.mobile, this.content);
      if (res.code == 1) {
        this.contacts = "";
        this.mobile = "";
        this.content = "";
        this.$message({
          message: '提交成功',
          type: 'success'
        });
      }
     // console.log(res);
    },
  },
};
</script>

<style scoped lang="scss">
@import "../assets/css/pc/index_contact.scss";
@import "../assets/css/move/index_contact.scss";
</style>